import SecureRequest from "../utils/securerequest";

export const getProcessStatus = async (invocationId) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const url = `/v3/process/${invocationId}/status`;
  const response = await Request.get(url);
  return response;
};

export const getProcessResult = async (invocationId, targetProcess, _generationAttemptId, correlationReceipt) => {
  const secureRequest = new SecureRequest();
  const request = secureRequest.getRequest();
  const headers = correlationReceipt
    ? { "X-Mira-Correlation-Receipt": correlationReceipt }
    : undefined;

  //if "bulkDownload" then modify the request to receive blob
  if (targetProcess === "bulkDownload") {
    const response = await request.get(`/v3/process/${invocationId}/result`, {
      responseType: "blob",
      headers: {
        ...headers,
        Accept: "application/zip, application/octet-stream",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    return {
      data: response.data,
    };
  } else {
    const url = `/v3/process/${invocationId}/result`;
    const response = headers ? await request.get(url, { headers }) : await request.get(url);
    return {
      data: response.data,
    };
  }
};

export const generateProcess = async (processData) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const url = `/v3/process/generate`;
  const response = await Request.post(url, processData);
  return response;
};

export const recordProcessPresented = async (invocationId, generationAttemptId, correlationReceipt) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return Request.post(`/v3/process/${invocationId}/presented`, {
    generation_attempt_id: generationAttemptId,
    ...(correlationReceipt ? { correlation_receipt: correlationReceipt } : {}),
  });
};
